const finEaseHomeNavigationRoutes = {
  FIN_EASE_HOME: "/",
  ADMIN: "/admin-login",
  ADMIN_DASHBOARD: "/admin-dashboard",
  DASHBOARD: "/dashboard",
  NPS_USER_LIST: "/user-list",
  NPS_USER_DETAILS: (id: string) => `/user-list/${id}`,
  NPS_USER_DETAILS_ROUTE: "/user-list/:id",
  ACTIVITY_LOG: "/admin/activity-log",
  USER_AUDIT_LOG: "/admin/logs/user-audit",
  API_ISSUE_LOG: "/admin/logs/api-issues",
  LOGIN_ACTIVITY_LOG: "/admin/logs/login-activity",
  SMS_ACTIVITY_LOG: "/admin/logs/sms-activity",
  USER_MANAGEMENT: "/admin/user-management",
  CMS_BANNERS: "/admin/cms/banners",
  CREATE_CMS_BANNER: "/admin/cms/banners/add",
  EDIT_CMS_BANNER: (id: string | number) => `/admin/cms/banners/edit/${id}`,
  EDIT_CMS_BANNER_ROUTE: "/admin/cms/banners/edit/:id",
  VIEW_CMS_BANNER: (id: string | number) => `/admin/cms/banners/view/${id}`,
  VIEW_CMS_BANNER_ROUTE: "/admin/cms/banners/view/:id",
  CMS_HOLIDAYS: "/admin/cms/holidays",
  CREATE_CMS_HOLIDAY: "/admin/cms/holidays/add",
  EDIT_CMS_HOLIDAY: (id: string | number) => `/admin/cms/holidays/edit/${id}`,
  EDIT_CMS_HOLIDAY_ROUTE: "/admin/cms/holidays/edit/:id",
  ADD_USER: "/admin/user-management/add",
  EDIT_USER: (id: string | number) => `/admin/user-management/edit/${id}`,
  EDIT_USER_ROUTE: "/admin/user-management/edit/:id",
  VIEW_USER: (id: string | number) => `/admin/user-management/view/${id}`,
  VIEW_USER_ROUTE: "/admin/user-management/view/:id",
  PAYMENT_ENTRY: "/admin/payment-entry",
  SETTLEMENTS: "/admin/settlements",
  IPO_MANAGEMENT: "/admin/ipo-management",
  CREATE_IPO: "/admin/ipo-management/add",
  EDIT_IPO: (id: string) => `/admin/ipo-management/edit/${id}`,
  EDIT_IPO_ROUTE: "/admin/ipo-management/edit/:id",
  IPO_ANALYTICS: "/admin/ipo-analytics",
  IPO_APPLICATIONS: "/admin/ipo-applications",
  BONDS: "/admin/bonds",
  FIXED_DEPOSITS: "/admin/fixed-deposits",
  IPO_VIEW: (id: string) => `/admin/ipo-management/view/${id}`,
  IPO_VIEW_ROUTE: "/admin/ipo-management/view/:id",
  CONTACT_QUERIES: "/admin/contact-queries",
  COMPANY_MASTER_LIST: "/admin/company-master-list",
  CATEGORY_MASTER: "/admin/category-master",
  CATEGORY_MASTER_ADD: "/admin/category-master/add",
  CATEGORY_MASTER_EDIT: (id: string) => `/admin/category-master/edit/${id}`,
  CATEGORY_MASTER_EDIT_ROUTE: "/admin/category-master/edit/:id",
  CATEGORY_MASTER_VIEW: (id: string) => `/admin/category-master/view/${id}`,
  CATEGORY_MASTER_VIEW_ROUTE: "/admin/category-master/view/:id",
  IPO_APPLICATION: "/admin/ipo-applications",
  PHYSICAL_GOLD_DASHBOARD: "/admin/physical-gold/dashboard",
  PHYSICAL_GOLD_PRODUCT_MASTER: "/admin/physical-gold/product-master",
  PHYSICAL_GOLD_ADD_PRODUCT: "/admin/physical-gold/product-master/add",
  PHYSICAL_GOLD_EDIT_PRODUCT: (id: string) =>
    `/admin/physical-gold/product-master/edit/${id}`,
  PHYSICAL_GOLD_EDIT_PRODUCT_ROUTE:
    "/admin/physical-gold/product-master/edit/:id",
  PHYSICAL_GOLD_PRICE_CONTROL: "/admin/physical-gold/price-control",
  PHYSICAL_GOLD_ORDERS: "/admin/physical-gold/orders",
  PHYSICAL_GOLD_ORDER_DETAILS: (id: string | number) =>
    `/admin/physical-gold/orders/${id}`,
  PHYSICAL_GOLD_ORDER_DETAILS_ROUTE: "/admin/physical-gold/orders/:id",
  PHYSICAL_GOLD_EDIT_ORDER: (id: string | number) =>
    `/admin/physical-gold/orders/edit/${id}`,
  PHYSICAL_GOLD_EDIT_ORDER_ROUTE: "/admin/physical-gold/orders/edit/:id",
  PHYSICAL_GOLD_SETTLEMENTS: "/admin/physical-gold/settlements",
  PHYSICAL_GOLD_SETTLEMENT_DETAILS: (id: string | number) =>
    `/admin/physical-gold/settlements/${id}`,
  PHYSICAL_GOLD_SETTLEMENT_DETAILS_ROUTE:
    "/admin/physical-gold/settlements/:id",
  PHYSICAL_GOLD_LOGS: "/admin/physical-gold/logs",
  PHYSICAL_GOLD_DELIVERY_MASTER: "/admin/physical-gold/delivery-master",
  PHYSICAL_GOLD_COMMISSION: "/admin/physical-gold/commission",
  PHYSICAL_GOLD_ADD_DELIVERY_MASTER: "/admin/physical-gold/delivery-master/add",
  PHYSICAL_GOLD_EDIT_DELIVERY_MASTER: (id: string | number) =>
    `/admin/physical-gold/delivery-master/edit/${id}`,
  PHYSICAL_GOLD_EDIT_DELIVERY_MASTER_ROUTE:
    "/admin/physical-gold/delivery-master/edit/:id",
  PHYSICAL_GOLD_VIEW_DELIVERY_MASTER: (id: string | number) =>
    `/admin/physical-gold/delivery-master/view/${id}`,
  PHYSICAL_GOLD_VIEW_DELIVERY_MASTER_ROUTE:
    "/admin/physical-gold/delivery-master/view/:id",
  IPO_MEMBER_MANAGEMENT: "/admin/ipo/member-management",
  CREATE_MEMBER: "/admin/ipo/member-management/add",
  EDIT_MEMBER: (id: string) => `/admin/ipo/member-management/edit/${id}`,
  EDIT_MEMBER_ROUTE: "/admin/ipo/member-management/edit/:id",
  VIEW_MEMBER: (id: string) => `/admin/ipo/member-management/view/${id}`,
  VIEW_MEMBER_ROUTE: "/admin/ipo/member-management/view/:id",
  IPO_PAST_ORDERS: "/admin/ipo/past-orders",
  IPO_ALLOTMENT: "/admin/ipo/allotment",
  IPO_ALLOTMENT_DETAILS: (id: string) => `/admin/ipo/allotment/${id}`,
  IPO_ALLOTMENT_DETAILS_ROUTE: "/admin/ipo/allotment/:id",
  QUERY_MASTER_ADMIN: "/admin/query-master-admin",
  QUERY_MASTER_ADMIN_ADD: "/admin/query-master-admin/add",
  QUERY_MASTER_ADMIN_EDIT: (id: string) =>
    `/admin/query-master-admin/edit/${id}`,
  QUERY_MASTER_ADMIN_EDIT_ROUTE: "/admin/query-master-admin/edit/:id",
  QUERY_MASTER_ADMIN_VIEW: (id: string) =>
    `/admin/query-master-admin/view/${id}`,
  QUERY_MASTER_ADMIN_VIEW_ROUTE: "/admin/query-master-admin/view/:id",
  QUERY_MASTER_USER: "/admin/query-master-user",
  QUERY_MASTER_USER_ADD: "/admin/query-master-user/add",
  QUERY_MASTER_USER_EDIT: (id: string) => `/admin/query-master-user/edit/${id}`,
  QUERY_MASTER_USER_EDIT_ROUTE: "/admin/query-master-user/edit/:id",
  QUERY_MASTER_USER_VIEW: (id: string) => `/admin/query-master-user/view/${id}`,
  QUERY_MASTER_USER_VIEW_ROUTE: "/admin/query-master-user/view/:id",
  QUERY_FIELD_MASTER: "/admin/query-field-master",
  QUERY_FIELD_MASTER_ADD: "/admin/query-field-master/add",
  QUERY_FIELD_MASTER_EDIT: (id: string) =>
    `/admin/query-field-master/edit/${id}`,
  QUERY_FIELD_MASTER_EDIT_ROUTE: "/admin/query-field-master/edit/:id",
  QUERY_FIELD_MASTER_VIEW: (id: string) =>
    `/admin/query-field-master/view/${id}`,
  QUERY_FIELD_MASTER_VIEW_ROUTE: "/admin/query-field-master/view/:id",
  ROLE_MANAGEMENT: "/admin/role-management",
  ROLE_MANAGEMENT_USERS: "/admin/role-management/users",
  ROLE_MANAGEMENT_ROLES: "/admin/role-management/roles",
  ROLE_MANAGEMENT_ADD: "/admin/role-management/add",
  ROLE_MANAGEMENT_EDIT: (id: string) => `/admin/role-management/edit/${id}`,
  ROLE_MANAGEMENT_EDIT_ROUTE: "/admin/role-management/edit/:id",
  ROLE_MANAGEMENT_VIEW: (id: string) => `/admin/role-management/view/${id}`,
  ROLE_MANAGEMENT_VIEW_ROUTE: "/admin/role-management/view/:id",
  EMAIL_WEBSITE_LEADS: "/admin/email/website",
} as const;

export default finEaseHomeNavigationRoutes;
